import { z } from 'zod';
import { createToolSignature } from './tool-signature';

const getActionsToolInputSchema = z.object({
    prospectIds: z.optional(
        z
            .array(z.string())
            .default([])
            .describe('A list of prospectIds to get actions for. If empty, all prospects will be considered.'),
    ),
});

type GetActionsToolInput = z.infer<typeof getActionsToolInputSchema>;
/**
 * Tool signature for getting actions for contacts.
 */
export const getActionsToolSignature = createToolSignature({
    name: 'getActionsTool',
    description:
        'Add a contact to a playbook. Returns a list of all playbooks including the groupId of each playbook and the assistantSettings. This tool is a good starting point when you get a question about a playbook.',
    inputSchema: getActionsToolInputSchema,
    outputSchema: z.object({
        actions: z.array(
            z.object({
                prospectId: z.string().describe('The id of the prospect'),
                suggestedActionId: z.string().describe('The id of the suggested action'),
                suggestedMessage: z.string().describe('The suggested message to send to the prospect'),
            }),
        ),
    }),
    toolCallUi: (input: GetActionsToolInput) => `Getting actions for contacts`,
});

const searchActionsToolInputSchema = z.object({
    query: z.string().describe('The query to search for actions'),
});

type SearchActionsToolInput = z.infer<typeof searchActionsToolInputSchema>;

/**
 * Tool signature for searching actions.
 */
export const searchActionsToolSignature = createToolSignature({
    name: 'searchActionsTool',
    description:
        'Analyzes conversations, prospects, and playbooks to recommend the most important actions a user should take to advance their relationship-building and sales goals.',
    inputSchema: searchActionsToolInputSchema,
    outputSchema: z.object({
        result: z.string(),
    }),

    toolCallUi(input: SearchActionsToolInput): string {
        return `Searching for actions`;
    },
});
